/**
 * This exception is fired when total audio duration is already at max and no more audio items
 * can be added
 */
export class AudioMaxDurationReachedException extends Error {}
